const API_URL = process.env.REACT_APP_API_URL;

export async function getGroupes() {
    const response = await fetch(`${API_URL}/groupe`, {
      method: "GET",
      credentials: "include",
    });
  
    if (!response.ok) {
      throw new Error("Non authentifié");
    }
    return response.json();
  }

// POST créer un groupe
export async function createGroupe(groupeData) {
    const response = await fetch(`${API_URL}/groupe/`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        groupe: {
          nom: groupeData.nom,
          couleur: groupeData.couleur
        }
      }),
    });
  
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors de la création du groupe");
    }
  
    return response.json();
}

// PUT mettre à jour un groupe
export async function updateGroupe(groupeId, groupeData) {
    const response = await fetch(`${API_URL}/groupe/${groupeId}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        groupe: {
          nom: groupeData.nom,
          couleur: groupeData.couleur
        }
      }),
    });
  
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors de la mise à jour du groupe");
    }
  
    return response.json();
}

// DELETE supprimer un groupe
export async function deleteGroupe(groupeId) {
    const response = await fetch(`${API_URL}/groupe/${groupeId}`, {
      method: "DELETE",
      credentials: "include",
    });
  
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors de la suppression du groupe");
    }
  
    return response.json();
}
  